const commonAndMisc = {
  errorMessage404: "Ooops! The page you are looking does not exist",
  errorContentUnavailable:
    "Ooops! The content you are looking for does not exist. Please contact us about the problem",
  backToHome: "Back to Home",
  information: "Information",
  additionalInformation: "Additional Information",
  destinationPlaceholder: "Where are you going",
  aboutUs: "About Us",
  pleaseWait: "Please wait...",
  featuredHotels: "Featured Hotels",
  topPackages: "Top Packages",
  topTours: "Top Tours",
  traveller: "Traveller",
  reviews: "Reviews",
  home: "Home",
  packages: "Packages",
  experiences: "Experiences",
  close: "Close",
  loadingMessage: "Please wait whilst we search for the best available prices",
  loadingMessageTheHotelCo:
    "Please wait whilst we search for the best available prices",
  loadingMessageSearchStrip:
    "Please wait while we search for the best prices available...",
  topCountriesToVisit: "Top Countries to Visit",
  profile: "Profile",
  reservations: "Reservations",
  myBookings: "My Bookings",
  address: "Address",
  firstName: "First Name",
  lastName: "Last Name",
  email: "Email",
  login: "Login",
  logout: "Logout",
  myProfile: "My Profile",
  myAccount: "My Account",
  myPoints: "My Points",
  myQuotations: "My Quotations",
  myChatRooms: "My Chats",
  chatRoomsListEmpty: "You have no chat rooms for this account.",
  chatRoomsOpen: "Open",
  chatRoomsLastActivity: "Last activity",
  chatRoomsUnread: "Unread",
  chatRoomsBadgeQuotation: "Quotation",
  chatRoomsBadgeTripOffer: "Trip offer",
  chatRoomsOpenQuotationAria: "Open quotation chat: {{name}}",
  chatRoomsOpenTripOfferAria: "Open trip offer chat: {{name}}",
  chatRoomsOpenGenericAria: "Open chat: {{name}}",
  quotationChatInvalidLink:
    "Invalid chat link. Open a chat from your profile or quotation list, or use exactly one of room_code or room_uid.",
  quotationChatNoTripDetails: "Trip details are not available for this chat.",
  chat: "Chat",
  verified: "Verified",
  unverified: "Unverified",
  selectLanguage: "Select language",
  selectCurrency: "Select currency",
  upgrade: "Upgrade",
  membership: "Membership",
  travelTrust: "Travel Trust",
  signInUp: "Sign In/Up",
  worldwideHotelsAndResortsAtAmazingWholesaleRates:
    "worldwide hotels and resorts at amazing wholesale rates",
  dashboard: "Dashboard",
  pricing: "Pricing",
  refundable: "Refundable",
  cars: "Cars",
  cruises: "Cruises",
  view: "View",
  price: "Price",
  totalPrice: "Total price",
  filterRoomName: "Filter room name",
  get: "Get",
  guestInformationValidation: "Guest Information Validation",
  reservation: "Reservation",
  checkIn: "Check In",
  checkOut: "Check Out",
  paymentInitiattionErroeMessage:
    "We couldn't initiate your payment process. We are sorry for the inconvenience",
  warning: "Warning",
  couldNotFindPriceForDateWarning:
    "We couldn't find a price for this date. Please try again for a different date",
  searchFormValidationError: "Search Form Validation Error",
  pleaseSelectValidDateFirst: "Please select a valid date first",
  searchError: "Search Error",
  priceSearchInitiationError:
    "We couldn't initiate the price search process. Please try again later. We are sorry for the inconvenience",
  searchWarning: "Search Warning",
  couldNotFindPriceAndOrAvailability:
    "We couldn't find price and/or availability for your request. We are sorry for the inconvenience",
  joinNow: " Join Now",
  signIn: "Sign In",
  searchNow: "Search now",
  bookingFailed: "Booking failed",
  sorryForTheInconvenience: "We are sorry for the inconvenience",
  contactUsToAssistWithYourBooking:
    "Please contact us to assist with your booking. We are sorry for the inconvenience",
  paymentFailedTryAgain: "Payment failed. Please try again",
  quickLinks: "Quick Links",
  tours: "Tours",
  termsAndConditions: "Terms and Conditions",
  pleaseWaitWhileInitiatingPayment:
    "Please wait while we are initiating your payment process",
  back: "Back",
  nextStep: "Next Step",
  book: "Book",
  checkout: "Checkout",
  specifyPickUpPoint: " Specify the point of your prefered pickup",
  pickupPoint: "Pickup Point",
  optional: "optional",
  provideImportantInfoForYourTravel:
    "Let us know of any information that would be important during your travel",
  remarks: "Remarks",
  travellerInformation: "Traveller Information",
  bookingRemarks: "Booking Remarks",
  bookingOverview: "Booking Overview",
  paymentFailed: "Payment Failed",
  paymentSuccess: "Payment Success",
  at: "At", // At date
  on: "On", // on date
  person: "person",
  cancellationPolicy: "Cancellation Policy",
  From: "From",
  to: "To",
  cancellationIs: "cancellation is",
  pickup: "Pickup",
  flights: "Flights",
  Accommodation: "Accommodation",
  payAndBook: "Pay & Book",
  onRequest: "On request",
  weAreFindingTheBestAvailableServices:
    "We are finding the best available services",
  withTheBestAvailablePrices: "with the best available prices",
  inRealTime: "in real time",
  seconds: "seconds",
  thisProcessCanTakeUpToOneMinute: "This process can take up to 1 minute",
  pleaseDoNotRefreshThisPage: "Please do not refresh this page",
  wellItSeemsItCanTakeBitLonger: "Well... it seems it can take a bit longer",
  yourBrowserDoesNotSupportTheVideoTag:
    "Your browser does not support the video tag",
  bookingSuccess: "Booking success",
  bookingReference: "Booking Reference",
  referenceCopied: "Reference copied",
  shortlyYouReceiveEmailContainingInformationForYourReservation:
    "Shortly, you will receive an email containing all the required information for your reservation",
  viewMore: "View more",
  readMore: "Read more",
  customerSupport: "Customer Support",
  socialMedia: "Social Media",
  hours: "hours",
  hour: "hour",
  minutes: "minutes",
  minute: "minute",
  memberId: "Member ID",
  star: "Star",
  stars: "Stars",
  proceed: "Proceed",
  clearAllFilters: "Clear all filters",
  clearYourFilters: "Please clear your filter options to view results",
  noOptionsForSelectedFilters: "No options available for matching your filters",
  privacyPolicy: "Privacy Policy",
  security: "Security",
  nearby: "Nearby",
  distanceFromSelection: "Distance from selection",
  km: "km",
  restaurants: "Restaurants",
  active: "Active",
  visitSite: "Visit site",
  score: "Score",
  applicationAvailable: "application available",
  sendUsEmail: "Send us an Email",
  sendUsYourRequest: "Send us your request",
  notAvailable: "Not Available",
  found: "Found",
  progressAt: "Progress at",
  currency: "Currency",
  sendUsRequest: "Send us your request",
  noReservationsForThisProduct: "No reservations for this product",
  noBookingsForThisProduct: "No bookings for this product",
  noReservationsOfThisProduct: "No reservations for this product type",
  actions: "Actions",
  save: "Save",
  confirmed: "Confirmed",
  cancelled: "Cancelled",
  pending: "Pending",
  notConfirmed: "Not Confirmed",
  status: "Status",
  reference: "Reference",
  leadGuest: "Lead Guest",
  sendVoucherEmail: "Send Voucher Email",
  sendCancellationEmail: "Send Cancellation Email",
  downloadVoucher: "Download Voucher",
  emailHasBeenSent: "Email successfully sent",
  emailNotSentTryAgain: "Email not sent! Please try again",
  titleIsRequired: "Title is required",
  genderIsRequired: "Gender is required",
  firstNameMustContainAlphabetic:
    "First name must contain alphabetic characters only",
  firstNameIsRequired: "First name is required",
  lastNameIsRequired: "Last name is required",
  lastNameMustContainAlphabetic:
    "Last name must contain alphabetic characters only",
  phoneNumberInTheFormat: "Phone number must be in the format with no spaces",
  phoneNumberIsRequired: "Phone number is required",
  emailIsRequired: "Email is required",
  invalidEmail: "Invalid email",
  addressIsRequired: "Address is required",
  cityIsRequired: "City is required",
  postalCodeIsRequired: "Postal code is required",
  countryIsRequired: "Country is required",
  yourReservationIsInProgress: "Your reservation is in progress",
  yourReservationHasBeenRegistered: "Your reservation has been registered",
  clickHere: "Click here",
  iHaveReadAgreeWithAbove: "I have read and agree with the above",
  pleaseCheckTheBox:
    "Please check the box at the bottom to indicate that you have read and agree with the provided information before proceeding to the next step.",
  pleaseAcceptProperty:
    "Please check the box at the top to indicate that the property that's being booked is the one you require.",
  ourContactNumbersAre: "Our contact numbers are",
  operationalHours: "Operational Hours",
  monday: "Monday",
  tuesday: "Tuesday",
  wednesday: "Wednesday",
  thursday: "Thursday",
  friday: "Friday",
  saturday: "Saturday",
  sunday: "Sunday",
  monday_to_friday: "Monday to Friday",
  closed: "Closed",
  topUpPoints: "Top Up Points",
  gender: "Gender",
  nationality: "Nationality",
  amountIn: "Amount In",
  amountOut: "Amount Out",
  maintenanceTitle: "Website under maintenance",
  maintenanceDescription:
    "We are performing scheduled maintenance. Please check back soon.",
  maintenanceCountdownLabel: "Estimated time remaining",
  maintenanceLogoAlt: "Website logo",
  maintenanceDays: "Days",
  maintenanceHours: "Hours",
  maintenanceMinutes: "Minutes",
  maintenanceSeconds: "Seconds",
  maintenanceStatusBadge: "Scheduled maintenance",
  maintenanceRefresh: "Refresh page",
  maintenanceExpired:
    "Maintenance should be complete shortly. Please refresh the page.",
};

export default commonAndMisc;
